import { render, staticRenderFns } from "./Shift.vue?vue&type=template&id=add97ce0&scoped=true"
import script from "./Shift.vue?vue&type=script&lang=js"
export * from "./Shift.vue?vue&type=script&lang=js"
import style0 from "./Shift.vue?vue&type=style&index=0&id=add97ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add97ce0",
  null
  
)

export default component.exports